import { Box } from '@mui/material'
import { LinearProgress, linearProgressClasses } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ProgressContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: 0
})

export const ProgressBar = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'small' && prop !== 'progresscolor'
})<{
  small?: boolean;
  progresscolor?: string;
}>(({ theme, small = false, progresscolor }) => {
  const thickness = small ? 4 : 8
  return {
    marginTop: theme.spacing(small ? 0.25 : 0.5),
    height: thickness,
    borderRadius: thickness,
    backgroundColor: theme.palette.divider,
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: thickness,
      backgroundColor: progresscolor
    }
  }
})

ProgressBar.defaultProps = {
  variant: 'determinate'
}

export const ValueText = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'small'
})<{ color?: string; small?: boolean }>(({ theme, color, small = false }) => ({
  color: color || theme.palette.text.secondary,
  fontSize: small ? '0.75rem' : '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: '0.5px'
  })
)
